import { Col, Row } from 'antd'
import { DatePicker, TimePickerRange } from 'components/atoms'
import { PLACE_HOLDER_EMPTY } from 'constants/placeholder'
import moment from 'moment'
import { DISABLED_HOURS_MORNING } from 'pages/menuWorkingSchedule/constants'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { getFromToDate } from 'utils'

const StyledContainer = styled(Row)`
  .ant-col .ant-col {
    padding: 0 !important;
    margin-top: 16px;
  }
`

export interface IFromToDateRange {
  from: number
  to: number
}
interface IProps {
  preventInput?: boolean
  onChange?: (fromTo: IFromToDateRange) => void
}
enum FormKey {
  Date = 'date',
  FromToTime = 'fromToTime'
}
const FromToDateRange = (props: IProps) => {
  const { preventInput, onChange } = props
  const { t } = useTranslation()
  const [date, setDate] = useState<any>(moment(new Date()))
  const [fromTo, setFromTo] = useState<any>([])

  const onFieldsChange = (value: any, fieldName: FormKey) => {
    switch (fieldName) {
      case FormKey.Date:
        setDate(value)
        if (fromTo?.[0]) {
          const fromToTime = getFromToDate(value, fromTo)
          if (onChange && fromToTime) {
            onChange(fromToTime)
          }
        }
        break
      case FormKey.FromToTime:
        setFromTo(value)
        if (value?.[0] && date) {
          const fromToTime = getFromToDate(date, value)
          if (onChange && fromToTime) {
            onChange(fromToTime)
          }
        }
        break
    }
  }

  return (
    <>
      <StyledContainer gutter={16}>
        <Col span={12}>
          <DatePicker
            title={t('date')}
            placeholder={PLACE_HOLDER_EMPTY}
            preventInput={preventInput}
            value={date}
            onChange={(value: any) => onFieldsChange(value, FormKey.Date)}
          />
        </Col>
        <Col span={24}>
          <TimePickerRange
            format="HH:mm"
            minuteStep={30}
            value={fromTo}
            onChange={(value: any) => onFieldsChange(value, FormKey.FromToTime)}
            disabledTime={() => {
              return {
                disabledHours: () => DISABLED_HOURS_MORNING
              }
            }}
          />
        </Col>
      </StyledContainer>
    </>
  )
}

export default FromToDateRange
